export const chronological = {
  title: 'Calendar Builder',
  subtitle: 'Build your itinerary by managing events from a Calendar View.',
  list: ['Ideal for any itinerary with lots of planned activities, transfers, flights, etc.'],
};

export const original = {
  title: 'Classic Builder',
  subtitle: 'Build your itinerary by @mentioning pages from your Content Library.',
  list: ['Ideal for simple hotel-only or property-based itineraries.'],
};

export const headerTitle = 'Select Itinerary Builder Mode';
export const footerText =
  'Heads up! Once you add any content to your details tab, you will not be able to switch to the other builder mode.';
